import { BaseError } from './base';

export function WritesToCollectionDisallowedError(message, debug, code, kinveyRequestId) {
  this.name = 'WritesToCollectionDisallowedError';
  this.message = message || 'This collection is configured to disallow any modifications to an existing entity or creation of new entities.';
  this.debug = debug || undefined;
  this.code = code || undefined;
  this.kinveyRequestId = kinveyRequestId || undefined;
  this.stack = (new Error()).stack;
}
WritesToCollectionDisallowedError.prototype = Object.create(BaseError.prototype);
WritesToCollectionDisallowedError.prototype.constructor = WritesToCollectionDisallowedError;



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/errors/writesToCollectionDisallowed.js